import {useEffect, useState, startTransition} from "react"

export const useMediaQuery = mediaQueryString => {
    const [matches, setMatches] = useState<any>(null)

    useEffect(() => {
        const mediaQueryList = window.matchMedia(mediaQueryString)
        const listener = () => startTransition(() => setMatches(!!mediaQueryList.matches))
        listener()
        mediaQueryList.addEventListener("change", listener)
        return () => mediaQueryList.removeEventListener("change", listener)
    }, [mediaQueryString])

    return matches
}

export default useMediaQuery
